import { render, staticRenderFns } from "./AddCurriculam.vue?vue&type=template&id=d4a9efd4&scoped=true"
import script from "./AddCurriculam.vue?vue&type=script&lang=js"
export * from "./AddCurriculam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a9efd4",
  null
  
)

export default component.exports